module.exports = __webpack_public_path__ + "static/media/close-icon.4dcddfd4.svg";